import PaymentMethodItem from './PaymentMethodItem';
export default PaymentMethodItem;
